import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class FlowchartManagerService {
  selectedElementView: joint.dia.ElementView;

  currentSearchResult = new BehaviorSubject<any>(null);

  setSelectedElementView(elementView: joint.dia.ElementView) {
    this.selectedElementView = elementView;
  }

  getSelectedElementView(): joint.dia.ElementView {
    return this.selectedElementView;
  }

  setSearchResult(component): void {
    this.currentSearchResult.next(component);
  }
}
